import { FileText, Users, UserPlus, BarChart3 } from "lucide-react"
import type { KpiAccent } from "@/components/common/KpiCard"
import type { LucideIcon } from "lucide-react"

export interface KpiDefinition {
  label: string
  value: string
  subtitle: string
  icon: LucideIcon
  accent: KpiAccent
}

export const DASHBOARD_KPIS: KpiDefinition[] = [
  {
    label: "Aktywne umowy",
    value: "—",
    subtitle: "ostatnie 30 dni",
    icon: FileText,
    accent: "blue",
  },
  {
    label: "Klienci",
    value: "—",
    subtitle: "łącznie w bazie",
    icon: Users,
    accent: "green",
  },
  {
    label: "Nowe leady",
    value: "—",
    subtitle: "ostatnie 30 dni",
    icon: UserPlus,
    accent: "amber",
  },
  {
    label: "Wygenerowane raporty",
    value: "—",
    subtitle: "ostatnie 30 dni",
    icon: BarChart3,
    accent: "violet",
  },
]
